export default __webpack_public_path__ + "static/media/phonepe.24f7742b.png";